import React, { useState } from 'react';
import { Button, InputNumber, Popover, message } from 'antd';
import orderService from '../../../../services/orderService';

const formatCurrency = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(n);
};

function orderRowId(row) {
  return row?.id ?? row?.uuid;
}

export default function RmPriceCell({ row, canManage, onUpdated }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(null);
  const [saving, setSaving] = useState(false);

  const displayValue =
    row?.rm_price != null && Number.isFinite(Number(row.rm_price))
      ? formatCurrency(row.rm_price)
      : '—';

  const handleOpenChange = (next) => {
    setOpen(next);
    if (next) {
      setDraft(row?.rm_price != null ? Number(row.rm_price) : null);
    }
  };

  const handleSave = async () => {
    const oid = orderRowId(row);
    if (!oid) {
      message.error('Order id missing');
      return;
    }

    if (draft != null && (!Number.isFinite(Number(draft)) || Number(draft) <= 0)) {
      message.warning('Enter a positive RM price or clear the field');
      return;
    }

    setSaving(true);
    try {
      await orderService.updateRmPrice(oid, draft ?? null);
      message.success('RM price updated');
      setOpen(false);
      await onUpdated?.();
    } catch (e) {
      message.error(
        e?.response?.data?.message || e?.message || 'Failed to update RM price'
      );
    } finally {
      setSaving(false);
    }
  };

  if (!canManage) {
    return displayValue;
  }

  const content = (
    <div className="w-56">
      <InputNumber
        className="w-full"
        min={0.01}
        precision={2}
        placeholder="RM price"
        value={draft}
        onChange={(v) => setDraft(v)}
      />
      <div className="flex justify-end gap-2 mt-3 pt-2 border-t border-gray-100">
        <Button size="small" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button size="small" type="primary" loading={saving} onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}
      trigger="click"
      content={content}
      placement="bottomLeft"
    >
      <div className="flex flex-col gap-0.5 min-w-[100px]">
        <span className="text-sm">{displayValue}</span>
        <Button type="link" size="small" className="h-auto p-0 text-left">
          {row?.rm_price != null ? 'Edit' : 'Set RM price'}
        </Button>
      </div>
    </Popover>
  );
}
